import React from 'react';

interface StepContainerProps {
  children: React.ReactNode;
  disableContinue?: boolean;
  error?: string;
  heading: string;
  nextStep: () => void;
  onContinue?: () => void;
  subheading: string;
}

type StepControlsProps = Omit<StepContainerProps, 'children' | 'heading' | 'subheading'>;

const StepControls = ({ nextStep, onContinue, disableContinue, error }: StepControlsProps) => {
  return (
    <div className="onboarding-footer">
      {error && <div className="onboarding-error mb2">{error}</div>}
      <button
        onClick={onContinue || nextStep}
        className="button button-red button-stretch button-small uppercase"
        disabled={disableContinue}
      >
        Continue
      </button>
      <button className="button button-small button-skip uppercase" onClick={nextStep}>
        Skip
      </button>
    </div>
  );
};

const StepContainer = ({
  heading,
  subheading,
  nextStep,
  onContinue,
  disableContinue,
  children,
  error,
}: StepContainerProps) => (
  <>
    <div className="onboarding-content">
      <h2 className="onboarding-heading">{heading}</h2>
      <p className="mt2">{subheading}</p>
      {children}
    </div>
    <StepControls
      nextStep={nextStep}
      onContinue={onContinue}
      disableContinue={disableContinue}
      error={error}
    />
  </>
);

export default StepContainer;
